import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddTagsModal from "../../components/modals/AddTagsModal/AddTagsModal";
import EditTagsModal from "../../components/modals/EditTagsModal/EditTagsModal";
import Pagination from "../../components/pagination/Pagination/Pagination";
import TagsTable from "../../components/Tables/TagsTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { ITags } from "../../types/tags.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterTags } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const TagsPage: React.FC = () => {
  const [tags, setTags] = useState<ITags[]>([]);
  const [filteredTags, setFilteredTags] = useState<ITags[]>([]);
  const [editSelectedTags, setEditSelectedTags] = useState<ITags | null>(null);
  const [visibleTags, setVisibleTags] = useState<ITags[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isAddTagModal, setIsAddTagModal] = useState<boolean>(false);
  const [isInfoModal, setInfoModal] = useState<boolean>(false);

  const getTags = async () => {
    try {
      const results = await authApiService.getAllTags();

      return results;
    } catch (err) {
      console.error(err);
    }
  };
  const changeVisibiltyTags = (tags: ITags[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (tags) {
      const changedTags = tags.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleTags(changedTags);
    }
  };

  const getOptionsFilter = () => {
    let filteredTags = [...tags];
    // setRole(role);

    // if (role.value !== EmployeeType.NONE) {
    //   filteredUsers = filteredUsers.filter((user) => user.role === role.value);
    // }

    return filteredTags;
  };

  const getFiltredTags = (tags: ITags[]) => {
    const data = getOptionsFilter();
    const filtered = filterTags(data, searchValue);
    setFilteredTags(filtered);
  };

  const onClickApplyModal = async () => {
    const resp = await getTags();
    if (resp) {
      setTags(resp);
      getFiltredTags(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredTags.length / usersPerPage));
  }, [filteredTags]);

  useEffect(() => {
    getFiltredTags(tags);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, tags]);

  useEffect(() => {
    (async () => {
      const data = await getTags();
      if (data) {
        setTags(data);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyTags(filteredTags);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, tags, totalPages, filteredTags]);
  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={tags?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddTagModal(true)}
            addButtonTitle="Додати conditions"
          />
        </div>
      </div>
      <TagsTable
        tags={visibleTags}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedTags}
      />
      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {isAddTagModal && (
        <AddTagsModal
          onClose={() => setIsAddTagModal(false)}
          onApply={onClickApplyModal}
        />
      )}

      {editSelectedTags && (
        <EditTagsModal
          tag={editSelectedTags}
          onClose={() => setEditSelectedTags(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
        />
      )}
    </main>
  );
};

export default TagsPage;
